/* Caipi Redesign — Rasen/Wiese Unterkategorie: Flächen-Rechner + FAQ + AJAX-Add. */
(function () {
  'use strict';

  function parseProducts(root) {
    var tag = root.querySelector('[data-rd-rasen-products]');
    if (!tag) return [];
    try {
      var list = JSON.parse(tag.textContent || '[]');
      return list.filter(function (p) { return p && p.area > 0; })
                 .sort(function (a, b) { return a.area - b.area; });
    } catch (e) { return []; }
  }

  function initCalc(root) {
    var calc = root.querySelector('[data-rd-rasen-calc]');
    if (!calc || calc.dataset.rdInit === '1') return;
    var range = calc.querySelector('[data-rd-area]');
    var valEl = calc.querySelector('[data-rd-area-val]');
    var rec = calc.querySelector('[data-rd-rec]');
    if (!range) return;
    calc.dataset.rdInit = '1';

    var products = parseProducts(root);
    var recLink = rec ? rec.querySelector('[data-rd-rec-link]') : null;
    var recSub = rec ? rec.querySelector('[data-rd-rec-sub]') : null;

    function recommend(target) {
      if (!products.length) return null;
      var pick = null;
      for (var i = 0; i < products.length; i++) {
        if (products[i].area >= target) { pick = products[i]; break; }
      }
      if (!pick) pick = products[products.length - 1]; // größter, wenn keiner reicht
      return pick;
    }

    function render() {
      var target = +range.value;
      if (valEl) valEl.textContent = target;
      var p = recommend(target);
      if (!p || !rec) return;
      if (recLink) {
        recLink.textContent = p.name;
        if (p.url) recLink.setAttribute('href', p.url);
      }
      if (recSub) {
        var parts = [];
        parts.push('reicht für ' + p.area + ' m²');
        if (p.price) parts.push(p.price);
        var sub = parts.join(' · ');
        if (p.area < target) sub += ' · ggf. mehrere Packungen';
        recSub.textContent = sub;
      }
      rec.removeAttribute('hidden');
    }

    range.addEventListener('input', render);
    render();
  }

  function initFaq(root) {
    var wrap = root.querySelector('[data-rd-rasen-faq]');
    if (!wrap || wrap.dataset.rdInit === '1') return;
    wrap.dataset.rdInit = '1';
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.rd-rsub__faq-q');
      if (!btn) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var ans = btn.parentNode.querySelector('.rd-rsub__faq-a');
      if (ans) { if (open) ans.setAttribute('hidden', ''); else ans.removeAttribute('hidden'); }
    });
  }

  function initAdd(root) {
    if (root.dataset.rdRsubAdd === '1') return;
    root.dataset.rdRsubAdd = '1';
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('.rd-rsub__form');
      if (!form) return;
      var btn = form.querySelector('button[name="add"]');
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      e.preventDefault();
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (r) { return r.ok; })
        .then(function (ok) {
          if (ok) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          }
        })
        .catch(function () {})
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  function boot() {
    document.querySelectorAll('.rd-rsub').forEach(function (r) { initCalc(r); initFaq(r); initAdd(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
